import { useState } from 'react';
import { Modal, Form, Col, Row, Spin } from 'antd';

import Button from '../../components/Button/Button';
import FormInput from '../../components/Forms/FormInput/FormInput';
import useLocale from '../../hooks/useLocale';

interface IProps {
  estateNumber?: string | null;
  onSave: (estateNumber: string, onSaveFailure?: () => void) => void;
  onCancel: () => void;
  shouldDisableOnSave?: boolean;
}

interface IForm {
  estateNumber: string;
}

const ChangeEstateNumberModal = ({ estateNumber: current, onSave, onCancel, shouldDisableOnSave = false }: IProps) => {
  const { t } = useLocale();
  const [form] = Form.useForm<IForm>();
  const [loading] = useState(false);
  const [disabled, setDisabled] = useState<boolean>(false);
  const [noChanged, setNoChanged] = useState<boolean>(true);

  const handleValuesChange = (val?: string) => {
    if (val !== undefined) setNoChanged(val === (current ?? ''));
  };

  // two digits, dash, seven digits (e.g., 11-1234567)
  const estateRegex = /^\d{2}-\d{7}$/;
  const validateEstateNumber = (_: any, value: any) => {
    if (!value || estateRegex.test(value)) return Promise.resolve();
    return Promise.reject();
  };

  return (
    <Modal
      destroyOnClose
      centered
      width={440}
      visible
      closable={!loading}
      title={t.ADMIN_INFO_ESTATE_NUMBER}
      onCancel={onCancel}
      footer={null}
    >
      <Spin spinning={loading}>
        <Form
          layout="vertical"
          form={form}
          onValuesChange={() => handleValuesChange(form.getFieldValue('estateNumber'))}
          onFinish={(values) => {
            if (shouldDisableOnSave) setDisabled(true);
            onSave(values?.estateNumber, () => {
              if (shouldDisableOnSave) setDisabled(false);
            });
          }}
        >
          <FormInput
            type="text"
            name="estateNumber"
            label={t.ADMIN_INFO_ESTATE_NUMBER}
            initialValue={current ?? ''}
            placeholder={t.ESTATE_NUMBER_PLACEHOLDER}
            rules={[
              { required: true, message: t.REQUIRED },
              { validator: validateEstateNumber, message: t.ESTATE_NUMBER_INVALID },
            ]}
          />
          <Row align="middle" justify="end" gutter={10} style={{ paddingTop: 16 }}>
            <Col>
              <Form.Item noStyle>
                <Button kind="cancel" onClick={onCancel}>
                  {t.CANCEL}
                </Button>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item noStyle>
                <Button kind="primary" htmlType="submit" disabled={disabled || noChanged}>
                  {t.SAVE}
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Spin>
    </Modal>
  );
};

export default ChangeEstateNumberModal;
